import { useState, useRef } from "react"
import Svg from "../_svgs/svg"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import LoginState from "../../booking/components/loginState"
import LanguageSelector from "./language-selector"
import UniverseSelectionBar from "./universe-selection-bar"

export default function HeaderMobile({
  isMobileMenuActive,
  logo,
  logoOverride,
  logoLink,
  logoTracking,
  handleMobileSearchOpen,
  handleMobileMenuToggle,
  languages,
  useParkingLanguageSelection,
  loginState,
  headerLinks,
  handleClickTracking,
  shopLogoTracking,
  shopLogoLink,
  shopLogo,
  menuToggleLabel,
  megaMenuCard,
  shopLogoLinkTarget,
  languageChoiceLabel,
  sectionNotAvailableText,
  pageNotAvailableText,
  universeSelection,
  universesSelectText,
  openBurgerMenuAriaLabel,
  closeBurgerMenuAriaLabel,
  langChoiceAriaLabel,
  searchButtonAriaLabel,
  mobileNavListRef,
  setIsMobileMenuActive,
  taxFreeAriaLabel,
}) {
  const burgerMenuRef = useRef(null)
  const closeButtonRef = useRef(null)

  return (
    <div className={`main-navigation--mobile js--mobile-navigation ${isMobileMenuActive ? "is-active is-fixed" : ""}`}>
      <div className="main-navigation--mobile__top">
        <a
          className={`button button--nav button--logo ${logoOverride && "button--logo--override"}`}
          href={logoLink}
          onClick={() => handleClickTracking(logoTracking)}
        >
          {logoOverride ? <img src={logoOverride} alt="Logo" /> : <Svg iconName={logo || "logo-tight"} />}
        </a>
        <div className="main-navigation__item main-navigation__item--search" onClick={() => handleMobileSearchOpen()}>
          <button id="search" aria-label={searchButtonAriaLabel} className="button button--nav button--nav--search">
            <Svg iconClass={"icon"} iconName={"search-new"} />
          </button>
        </div>

        {/* mobile focus close technique */}
        {isMobileMenuActive && (
          <button
            style={{
              position: "absolute",
              background: "transparent",
              height: "1px",
              width: "1px",
              display: "inline-block",
              fontSize: "0px",
            }}
            tabIndex={0}
            onFocus={() => {
              setTimeout(() => {
                closeButtonRef.current.focus()
              }, 50)
            }}
          >
            {closeBurgerMenuAriaLabel}
          </button>
        )}

        <button
          ref={burgerMenuRef}
          id={"mobilenavopen"}
          aria-label={openBurgerMenuAriaLabel}
          aria-expanded={isMobileMenuActive}
          className="button button--toggle js--navigation-toggle"
          onClick={() => {
            if (isMobileMenuActive) {
              closeButtonRef.current && closeButtonRef.current.focus()
            } else {
              handleMobileMenuToggle()
            }
          }}
        >
          <Svg iconClass={"icon"} iconName={"burgermenu"} />
        </button>
      </div>
      <ul
        tabIndex={"-1"}
        className={`main-navigation--mobile__list js--navigation-inner ${isMobileMenuActive ? "is-active" : "v-hidden"}`}
        ref={mobileNavListRef}
      >
        <li>
          <div className="main-navigation--mobile__list__top">
            <LanguageSelector
              languageChoiceLabel={languageChoiceLabel}
              languages={languages}
              useParkingLanguageSelection={useParkingLanguageSelection}
              langChoiceAriaLabel={langChoiceAriaLabel}
            />

            <div className={`main-navigation__item main-navigation__item--user`}>
              <LoginState config={loginState} />
            </div>
            <button
              ref={closeButtonRef}
              aria-label={closeBurgerMenuAriaLabel}
              className="button button--toggle js--navigation-toggle close"
              onClick={() => {
                handleMobileMenuToggle(),
                  setTimeout(() => {
                    burgerMenuRef.current.focus()
                  }, 50)
              }}
            >
              <Svg iconClass={"icon2"} iconName={"close-new"} />
            </button>
          </div>
        </li>
        {headerLinks && headerLinks.length > 0
          ? headerLinks.map((item, index) => {
              return (
                <MobileLinkList
                  key={"mobileLinkList" + index}
                  megaMenuCard={megaMenuCard}
                  link={item.link}
                  menuToggleLabel={menuToggleLabel}
                  linkText={item.linkText}
                  handleClickTracking={handleClickTracking}
                  sectionNotAvailableText={sectionNotAvailableText}
                  pageNotAvailableText={pageNotAvailableText}
                  isMobileMenuActive={isMobileMenuActive}
                  setIsMobileMenuActive={setIsMobileMenuActive}
                  {...item}
                />
              )
            })
          : ""}
        {shopLogo && shopLogoLink ? (
          <li className="taxfreelink">
            <a href={shopLogoLink} onClick={() => handleClickTracking(shopLogoTracking)} target={shopLogoLinkTarget}>
              <img src={shopLogo} alt={taxFreeAriaLabel || "Tax Free"} />
            </a>
          </li>
        ) : (
          ""
        )}
        <li>
          <UniverseSelectionBar universeSelection={universeSelection} universesSelectText={universesSelectText} isMobile={true} />
        </li>
      </ul>
      {/* mobile focus close technique */}
      {isMobileMenuActive && (
        <button
          style={{
            position: "absolute",
            background: "transparent",
            height: "1px",
            width: "1px",
            display: "inline-block",
            fontSize: "0px",
          }}
          tabIndex={0}
          onFocus={() => {
            // handleMobileMenuToggle(),
            setTimeout(() => {
              closeButtonRef.current.focus()
            }, 50)
          }}
        >
          {/* {closeBurgerMenuAriaLabel} */}
        </button>
      )}
    </div>
  )
}

function MobileLinkList({
  megaMenuCard,
  menuToggleLabel,
  link,
  linkText,
  handleClickTracking,
  sectionNotAvailableText,
  pageNotAvailableText,
  isMobileMenuActive,
  setIsMobileMenuActive,
}) {
  const [isToggle, setIsToggle] = useState(false)

  //TODO - Do this with React
  const showHideContent = (event, classname) => {
    setIsToggle(!isToggle)
    let elem = event.currentTarget
    elem.__toggle = !elem.__toggle
    let target = elem.parentElement.querySelector(classname)
    if (elem.__toggle) {
      target.style.height = target.scrollHeight + "px"
      elem.classList.add("is-active")
    } else {
      target.style.height = 0 + "px"
      elem.classList.remove("is-active")
    }
  }

  const getLinkList = (linkArea, megaMenuElements) => {
    let linkList = []
    if (linkArea) {
      linkList = linkList.concat(linkArea)
    }

    if (megaMenuElements) {
      megaMenuElements.forEach((elem) => {
        if (elem.__type__ === "MegaMenuLinkListElement") {
          const firstLink = { ...elem.firstLink }
          firstLink.isFirstLink = true
          linkList.push(firstLink)
          linkList = linkList.concat(elem.linkArea)
        } else {
          linkList.push(elem.linkItem)
        }
      })
    }

    return linkList
  }

  let linkList = []
  if (megaMenuCard) linkList = getLinkList(megaMenuCard.linkArea, megaMenuCard.megaMenuElements)

  const showAnnotation = megaMenuCard.annotate || (!megaMenuCard.annotate && megaMenuCard.hasAnnotatedLinks)
  return (
    <li>
      <div className="mobile-navigation__links">
        <div className="topmenuitem button button--link has-icon" onClick={(e) => showHideContent(e, ".contentWrapper")}>
          <a className="text" href={link} tabIndex={isMobileMenuActive ? 0 : -1}>
            {linkText}
          </a>
          <button
            aria-expanded={isToggle}
            aria-label={menuToggleLabel ? `${menuToggleLabel.formatUnicorn({ menutext: linkText || "" })}` : `Toggle ${linkText}`}
            aria-haspopup={"menu"}
            className={"expand--toggle"}
          >
            <Svg iconClass={"icon-toggle"} stroke={"#4e55ab"} iconName={"menu-expand"} isDecorative={true} />
          </button>
        </div>
        <div className={`contentWrapper show-hide${isToggle ? "" : " v-hidden"}`}>
          {showAnnotation ? (
            <div className={`annotation-text`}>
              {megaMenuCard.annotate ? <p>{sectionNotAvailableText.replace("*", "").replace("{headline}", linkText)}</p> : ""}
              {!megaMenuCard.annotate && megaMenuCard.hasAnnotatedLinks ? <p>{pageNotAvailableText}</p> : ""}
            </div>
          ) : (
            ""
          )}
          <ul className={"links-list"}>
            {linkList && linkList.length > 0
              ? linkList.map((link, index) => {
                  const linkTarget = SelectionFactoryHelper.getFromSelectionFactory(link.linkTarget)
                  return (
                    <li key={index} className="links-list__item">
                      <a
                        tabIndex={isToggle ? 0 : -1}
                        className={`button button--link has-icon ${link.isFirstLink ? "first-link" : ""}`}
                        target={linkTarget}
                        href={link.linkUrl}
                        onClick={() => handleClickTracking(link.linkTracking)}
                      >
                        <span className="text">{`${link.linkText}${!megaMenuCard.annotate && link.annotate ? "*" : ""}`}</span>
                      </a>
                    </li>
                  )
                })
              : ""}
          </ul>
        </div>
      </div>
    </li>
  )
}
